var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommentGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15743_39785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 9.33333C6.66663 8.78105 7.11434 8.33333 7.66663 8.33333H15C15.5522 8.33333 16 8.78105 16 9.33333C16 9.88562 15.5522 10.3333 15 10.3333H7.66663C7.11434 10.3333 6.66663 9.88562 6.66663 9.33333Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66663 11.3333C7.11434 11.3333 6.66663 11.781 6.66663 12.3333C6.66663 12.8856 7.11434 13.3333 7.66663 13.3333H12.3333C12.8856 13.3333 13.3333 12.8856 13.3333 12.3333C13.3333 11.781 12.8856 11.3333 12.3333 11.3333H7.66663Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66663 10.3333C2.66663 6.83553 5.50216 4 8.99996 4H15C18.4978 4 21.3333 6.83553 21.3333 10.3333V11.3333C21.3333 14.8311 18.4978 17.6667 15 17.6667H12.832L8.595 20.8037C8.29148 21.0284 7.88725 21.063 7.54998 20.893C7.21272 20.7231 6.99996 20.3777 6.99996 20V17.3441C4.48224 16.5066 2.66663 14.1329 2.66663 11.3333V10.3333ZM8.99996 6C6.60673 6 4.66663 7.9401 4.66663 10.3333V11.3333C4.66663 13.4478 6.18202 15.2104 8.18633 15.5906C8.65833 15.6801 8.99996 16.0927 8.99996 16.5731V18.0154L11.9071 15.863C12.0793 15.7355 12.2879 15.6667 12.5021 15.6667H15C17.3932 15.6667 19.3333 13.7266 19.3333 11.3333V10.3333C19.3333 7.9401 17.3932 6 15 6H8.99996Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15743_39785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommentGray);
export default __webpack_public_path__ + "static/media/iconCommentGray.04df89a2f00494b31d902de2edcc77d0.svg";
export { ForwardRef as ReactComponent };